<template>
    <div class="w-full">
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="w-[70%] mx-auto bg-white rounded-lg p-6 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                    <p class="text-gray-700 mb-4">Date:</p>
                    <h2 class="text-xl font-bold text-center mb-4">Subject: Salary Domiciliation</h2>

                    <div class="mb-4">
                        <p class="text-gray-700 mb-4">
                            To President Saliou Toure<br>
                            BP 564 Grand-Bassam
                        </p>
                        <p class="text-gray-700 mb-4">
                            Dear Mr. President,
                        </p>
                        <p class="text-gray-700 mb-4">
                            I have the honor to request, through this letter, that you kindly transfer the entirety of my monthly salary and any other remuneration owed to me to my bank account held with [Name of the Bank], account number N° [Account Number].
                        </p>
                        <p class="text-gray-700 mb-4">
                            This request for salary domiciliation also applies to any amounts you may owe me in relation to the termination of our professional relationship, if applicable. [cite: 1, 2]
                        </p>
                        <p class="text-gray-700">
                            My salary domiciliation instructions are permanent and can only be revoked with the written and formal consent of the [Name of the Bank] management. [cite: 3]
                        </p>
                        <p class="text-gray-700 mt-4">
                            Please accept, Mr. President, the expression of my deepest respect.
                        </p>
                    </div>

                    <div>
                        <p class="text-gray-700">
                            [Name, position, department and Signature of the requester] [cite: 4]
                        </p>
                    </div>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "SalaryDomiciliationValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            nom: null,
            prenom: null,
            startDate: null,
            endDate: null,
            returnTime: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.prenom= JSON.parse(data.data["data"]["content"]).prenom
                    this.startDate= JSON.parse(data.data["data"]["content"]).startDate
                    this.endDate= JSON.parse(data.data["data"]["content"]).endDate
                    this.returnTime= JSON.parse(data.data["data"]["content"]).returnTime
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            const signature = localStorage.getItem("signature") ?? undefined;
            if(!signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : localStorage.getItem("signature")
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        console.log(response.data);
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>